import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';

const ThemeSwitcher = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="theme-switcher" title="Appearance Settings">
      <button
        type="button"
        className={`theme-option-btn ${theme === 'light' ? 'active' : ''}`}
        onClick={() => setTheme('light')}
        aria-label="Light mode"
      >
        <FiSun size={14} /> Light
      </button>
      <button
        type="button"
        className={`theme-option-btn ${theme === 'dark' ? 'active' : ''}`}
        onClick={() => setTheme('dark')}
        aria-label="Dark mode"
      >
        <FiMoon size={14} /> Dark
      </button>
    </div>
  );
};

export default ThemeSwitcher;
